import * as React from 'react'
import './index.scss'
import { ModuleLayoutProps } from './types'
import { Icon } from '@petz/ds-icon'
import { ModuleContext } from '../../hooks/ModuleContext'

export const ModuleLayout: React.FC<ModuleLayoutProps> = ({ children }: ModuleLayoutProps) => {
  const { setModule } = React.useContext(ModuleContext)

  return (
    <div className="module-layout">
      <button className="return-button" onClick={() => setModule('all')}>
        <Icon name="arrow-left" variant="line" size="xs" />
        <p className="return-button-text">Voltar</p>
      </button>
      {children}
    </div>
  )
}
